const _SELF_REGEX_ = /^(?:CO|PO|LU|OU)-(?:PX|AD|PN|VD)-[0-9]{4}-[0-9]*$/

export class ProcedureId {
  private value: string

  constructor (id: string) {
    if (!_SELF_REGEX_.test(id)) {
      throw new TypeError('Wrong format for Procedure Id')
    }
    this.value = id
  }

  get id (): string {
    return this.value
  }
}
